export const fbdnAccordionContentDirective: IDirectiveFactory = function() {
   return {
      require: '^subPanel',
      transclude: 'element',
      link: function(_scope: IScope, element: JQLite, _attrs: IAttributes, subPanelController: IController, transclude: ITranscludeFunction) {
         subPanelController.add(element, transclude);
      }
   };
};
